export function getBusinessDateToday(timeZone: string, now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value;

  return `${value("year")}-${value("month")}-${value("day")}`;
}

export function isBusinessDateToday(date: string, timeZone: string, now = new Date()) {
  return date.slice(0, 10) === getBusinessDateToday(timeZone, now);
}
/** Calendar dates retain their written day; never round-trip them through UTC. */
export function toNullableApiDate(value: string | Date | null | undefined): string | null {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    if (!Number.isFinite(value.getTime())) throw new RangeError("Invalid calendar date");
    return toNullableApiDate(`${String(value.getFullYear()).padStart(4, "0")}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`);
  }
  // Accept existing API ISO timestamps, retaining the calendar portion as written.
  const match = /^(\d{4}-\d{2}-\d{2})(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?$/.exec(value);
  if (!match) throw new RangeError("Invalid calendar date");
  const day = match[1];
  const parsed = new Date(`${day}T00:00:00Z`);
  if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== day ||
      (value.length > 10 && !Number.isFinite(Date.parse(value)))) {
    throw new RangeError("Invalid calendar date");
  }
  return day;
}
